import { render, staticRenderFns } from "./StatisticsSalesItemsAll.vue?vue&type=template&id=1e1e778f&scoped=true&"
import script from "./StatisticsSalesItemsAll.vue?vue&type=script&lang=js&"
export * from "./StatisticsSalesItemsAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1e778f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e1e778f')) {
      api.createRecord('1e1e778f', component.options)
    } else {
      api.reload('1e1e778f', component.options)
    }
    module.hot.accept("./StatisticsSalesItemsAll.vue?vue&type=template&id=1e1e778f&scoped=true&", function () {
      api.rerender('1e1e778f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Dashboard/StatisticsSalesItemsAll.vue"
export default component.exports